module.exports = "pegasus/assets/theme3/small/4.jpg";